import { RMA_STATUS_LABEL, RMA_STATUS_TINT } from "../../lib/rma";

const PILL_BASE =
  "inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide";

export default function RMAStatusBadge({ status, size = "sm" }) {
  const tint =
    RMA_STATUS_TINT[status] || "bg-slate-100 text-slate-700 border-slate-300";
  const label = RMA_STATUS_LABEL[status] || status;
  const sizeCls =
    size === "lg"
      ? "px-3 py-1 text-xs"
      : size === "md"
      ? "px-2.5 py-0.5 text-[11px]"
      : "";
  return (
    <span
      data-testid={`rma-status-${status}`}
      className={`${PILL_BASE} ${tint} ${sizeCls}`}
    >
      {label}
    </span>
  );
}
